import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { selectClientValue } from "../../../App/State/Slices/SelectedClientSlice";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import { selectUserPermissionsValue } from "../../../App/State/Slices/UserPermissionsSlice";
import { CheckRoleForClient } from "../../../App/Helpers/PermissionsChecks";
import { Roles } from "../../../App/Enums/Roles";
import { getAllRoles } from "../../../App/Services/UserService";
import { CRMRoles } from "../../../App/Enums/CRMRoles";

/**
 * @description Sets up the Role Selection state used by both User Management and User Creation
 */
export function useRoleSelectionState() {
  const selectedClient = useSelector(selectClientValue);
  const selectedCareersClient = useSelector(selectCareersClientValue);
  const userPermissions = useSelector(selectUserPermissionsValue);

  const [roles, setRoles] = useState([]);

  const [selectedRole, setSelectedRole] = useState("");
  const [selectedCRMRole, setSelectedCRMRole] = useState(CRMRoles[0]);
  const [selectedRights, setSelectedRights] = useState(0);

  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLightAdmin, setIsLightAdmin] = useState(false);
  const [isClientAdmin, setIsClientAdmin] = useState(false);

  const superAdminRolesToRemove = [Roles.FeedsAdmin, Roles.OutboundFeedsAdmin];
  const adminRolesToRemove = [...superAdminRolesToRemove, Roles.SuperAdmin];
  const lightAdminRolesToRemove = [...adminRolesToRemove, Roles.Admin];
  const clientAdminRolesToRemove = [
    ...lightAdminRolesToRemove,
    Roles.LightAdmin,
  ];
  const manageUserRolesToRemove = [
    ...clientAdminRolesToRemove,
    Roles.ClientAdmin,
  ];

  function getCurrentRole() {
    if (
      CheckRoleForClient(
        userPermissions,
        selectedClient.id.toUpperCase(),
        Roles.SuperAdmin
      ) === true
    ) {
      setIsSuperAdmin(true);
    } else if (
      CheckRoleForClient(
        userPermissions,
        selectedClient.id.toUpperCase(),
        Roles.Admin
      ) === true
    ) {
      setIsAdmin(true);
    } else if (
      CheckRoleForClient(
        userPermissions,
        selectedClient.id.toUpperCase(),
        Roles.LightAdmin
      ) === true
    ) {
      setIsLightAdmin(true);
    } else if (
      CheckRoleForClient(
        userPermissions,
        selectedClient.id.toUpperCase(),
        Roles.ClientAdmin
      ) === true
    ) {
      setIsClientAdmin(true);
    }
  }

  function filterRoles() {
    var filteredRoles = [];
    isSuperAdmin
      ? (filteredRoles = roles.filter(
          (r) => !superAdminRolesToRemove.includes(r.id.toUpperCase())
        ))
      : isAdmin
      ? (filteredRoles = roles.filter(
          (r) => !adminRolesToRemove.includes(r.id.toUpperCase())
        ))
      : isLightAdmin
      ? (filteredRoles = roles.filter(
          (r) => !lightAdminRolesToRemove.includes(r.id.toUpperCase())
        ))
      : isClientAdmin
      ? (filteredRoles = roles.filter(
          (r) => !clientAdminRolesToRemove.includes(r.id.toUpperCase())
        ))
      : (filteredRoles = roles.filter(
          (r) => !manageUserRolesToRemove.includes(r.id.toUpperCase())
        ));

    return filteredRoles;
  }

  useEffect(() => {
    getCurrentRole();
    getAllRoles().then((response) => {
      setRoles(response);
    });
  }, []);

  return {
    effects: {},
    getters: {
      roles,
      selectedRole,
      selectedRights,
      selectedCRMRole,
      isSuperAdmin,
      isAdmin,
      isLightAdmin,
      isClientAdmin,
      selectedClient,
      selectedCareersClient,
      userPermissions,
    },
    handlers: { filterRoles },
    setters: {
      setRoles,
      setSelectedRole,
      setSelectedRights,
      setSelectedCRMRole,
      setIsSuperAdmin,
      setIsAdmin,
      setIsLightAdmin,
      setIsClientAdmin,
    },
  };
}
